import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { RequestsService } from '../services/requests.service';
import * as XLSX from 'xlsx';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-pick-drop-request',
  templateUrl: './pick-drop-request.component.html',
  styleUrls: ['./pick-drop-request.component.sass']
})
export class PickDropRequestComponent implements OnInit {
  searchText:any;
  page: number = 0;
  itemsPerPage = 5;
  totalItems:any;
  allFareEstimateList:any;

  allFareEstimateList_forFilter:any;
  closeResult: string;
  viewAllData:any;
  constructor(private toastr:ToastrService,
              private spinner :NgxSpinnerService,
              private requestsService : RequestsService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getFareRequests()
  }


  getFareRequests(){
    this.spinner.show();       
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    : 0,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      //  "isDeleted": 2        // 2 for getting all users
    }
    this.requestsService.getFareRequests(data).subscribe((result:any)=>{
      console.log('all data  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allFareEstimateList = result.data
        this.allFareEstimateList_forFilter = result.data
        this.totalItems = result.totalRecords;
      }else{
        this.allFareEstimateList = [];
        this.allFareEstimateList_forFilter = [];
      }
    })
  }

  gty(page: any){
    this.spinner.show();
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    :this.page-1,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      // "isDeleted": 2        // 2 for getting all users
    }
    this.requestsService.getFareRequests(data).subscribe((result:any)=>{
      console.log('all data  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allFareEstimateList = result.data
        this.allFareEstimateList_forFilter = result.data
      }else{
        this.allFareEstimateList = [];
        this.allFareEstimateList_forFilter = [];
      }
    })
  }




  applyFilter(filterValue:any){
    console.log(filterValue);
    let filterValueLower = filterValue.toLowerCase();
         if(filterValue === '' ) {
             this.allFareEstimateList=this.allFareEstimateList_forFilter;
         } 
         else {
           this.allFareEstimateList = this.allFareEstimateList_forFilter.filter((employee:any) => employee.pickup.toLowerCase().includes(filterValueLower) )
          }
  }


  viewDetails(content1 ,data){
    this.viewAllData = data;
    this.openViewDeatilsModal(content1);
  }

  exportToExcel(){
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "Pick-Drop Report.xlsx");
   }


   openViewDeatilsModal(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}
